import React, { useEffect, useState } from 'react';

export default function PageLoader({ message = "Loading..." }) {
  const [dots, setDots] = useState('.');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '.' : prev + '.');
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="flex flex-col items-center gap-6">
        <div className="relative">
          <div className="page-loader-spinner" />
          <div className="absolute inset-0 page-loader-spinner-backdrop" />
        </div>
        <p className="text-sm text-muted-foreground animate-pulse">
          {message}{dots}
        </p>
      </div>
    </div>
  );
}